<template>
  <div class="login wrap">
    <div class="header">
      <header>
        <NavBar :title="title" left-arrow @click-left="$router.go(-1)" />
      </header>
    </div>
    <div class="main">
      <!-- <p class="sub_title">注册页</p> -->
      <Form class="forms"  ref="form"  inputVail="true">
        <Field
          v-model="email"
          placeholder="Email Address"
          name="email"
          clearable
          :rules="[{
            required: true,
            validator: FormHlep.IsEmal,
            message: 'Please enter your vaild email'
          }]"/>

        <!-- 密码 -->
        <Field
          v-model="password"
          clearable
          placeholder="Password"
          type="password"
          :rules="[{
            required: true,
            message: 'Please enter the password'
          }]"
        ></Field>
        <!-- 输入验证码 -->
        <Field
          v-model="code"
          clearable
          placeholder="Enter Captcha"
          :rules="[{
            required: true,
            message: 'Please enter verification code'
          }]">
          <!-- 忘记密码 -->
          <Button slot="button" color="#16C7CE" size="small" @click="getYzm()">Send Code</Button>
        </Field>

      </Form>
      <div class="protocol" v-if="!$route.query.Reset">
        <div class="FlexBox">
          <Checkbox v-model="aa" shape="square" bind:change="CheckboxFn" />
          <span class="CheckText">I have read and agree to</span>
        </div>
        <span style="color:#16C7CE">TERMS OF SERVICE</span>
      </div>
      <div class="Btn">
        <!-- 登陆 -->
        <Button v-if="$route.query.Reset"
          class="BtnTop"
          color="#16C7CE"
          type="primary"
          block
          @click="Submit"
          >CONFIRM</Button
        >
        <Button v-else
          class="BtnTop"
          color="#16C7CE"
          type="primary"
          block
          @click="Submit"
          >REGISTER</Button
        >
        <!-- 创建用户 -->
        <Button v-if="!$route.query.Reset" block>Log In Now</Button>
      </div>
    </div>
  </div>
</template>
<script>
import sha256 from 'sha256'
import { toReverse} from '../../utils/common'
import FormHlep from "@/utils/formHlep"; //正则
import request from "../../api/request";
export default {
  data() {
    return {
      title:'Register',
      FormHlep,
      email: '',
      password: '',
      code: '',  //验证码
      aa: true,
    };
  },
  created() {
    console.log(this.$route.query.Reset)
    if(this.$route.query.Reset){
      this.title='Reset Password'
    }
  },
  methods: {
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    
    // 表单通过提交
    Submit() {   // 注册
      // 全局表单验证.
      this.$refs['form'].validate().then(()=>{
        let data = { 
          code :this.code,  //邮箱验证码
          email: this.email, 
          password:sha256(toReverse(this.password))
        }; //发邮件类型[REGISTER(注册), UPDATE_EMAIL(修改账号), UPDATE_PASSWORD(修改密码)]
        console.log(data)
        let url 
        if(this.$route.query.Reset){
          url = 'app/authentication/reset-password'    //重置密码
        }else{
          url = 'cms/authentication/sign-up'      //注册账号
        }
        request("post", url, data).then(res => {
          if (res.code === 200) {
            // this.$toast.success("操作成功");
            this.$router.push('/login')
          }
        });
      }).catch(()=>{
        // this.$toast.fail("提交失败");
      })
    },
    getYzm() {
      this.$refs.form.validate('email').then(()=>{
        let data
        if(this.$route.query.Reset){    //修改密码的验证码
          data = { 
            email: this.email,
            kind: "UPDATE_PASSWORD" 
          }; //发邮件类型[REGISTER(注册), UPDATE_EMAIL(修改账号), UPDATE_PASSWORD(修改密码)]
          request("post", "app/authentication/email-verify", data).then(res => {
            if (res.code === 200) {
            }
          });
        }else{   //注册的验证码
          data = { 
            email: this.email,
            kind: "REGISTER" 
          }; //发邮件类型[REGISTER(注册), UPDATE_EMAIL(修改账号), UPDATE_PASSWORD(修改密码)]
          request("post", "app/authentication/email-verify", data).then(res => {
            if (res.code === 200) {
              console.log(res);
              // this.$router.push('/productList')
            }
          });
        }
      }).catch(()=>{})
    }
  }
};
</script>
<style lang="less" scoped>
.login {
  .sub_title {
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    margin: 100px 0 20px 0;
    color: #333;
    word-break: normal;
  }
  .CheckText{
    padding-left: 10px;
  }
  .forms{
    margin-top: 10px;
  }
  .protocol {
    display: flex;
    padding: 0px 10px;
    justify-items: center;
    justify-content: space-between;
    margin: 20px 0;
    font-size: 12px;
  }
  .Btn {
    padding: 0 10px;
    .BtnTop {
      margin: 30px 0 10px 0;
    }
  }
}
</style>
<style>
.login .van-checkbox__icon .van-icon {
  font-size: 12px;
}
</style>
